import styled from 'styled-components';
import { ButtonPrimary, ButtonTertiary } from '@spotify-internal/encore-web';
import { useT } from '@spotify-internal/i18n-core';

const StyledButtonPrimary = styled(ButtonPrimary)`
  cursor: pointer;
`;

const StyledButtonTertiary = styled(ButtonTertiary)`
  cursor: pointer;
`;

const StyledBackButton = styled(StyledButtonTertiary)`
  margin-inline-end: auto;
`;

interface FooterButtonsProps {
  onClose: () => void;
  submitButtonDisabled: boolean;
  isFetched: boolean;
  lastBtnRef: React.MutableRefObject<HTMLElement | null>;
  /** Which page of the form is currently shown. Defaults to 1. */
  page?: 1 | 2;
  /** Called when the user clicks Next on page 1. */
  onNext?: () => void;
  /** Called when the user clicks Back on page 2. */
  onBack?: () => void;
  /** When true page 1 shows "Next" → page 2; when false shows legacy "Submit". */
  enablePage2?: boolean;
}
export const FooterButtons = ({
  onClose,
  submitButtonDisabled,
  isFetched,
  lastBtnRef,
  page = 1,
  onNext,
  onBack,
  enablePage2 = false,
}: FooterButtonsProps) => {
  const t = useT();

  return (
    <>
      {page === 2 && (
        <StyledBackButton
          type="button"
          buttonSize="sm"
          condensed
          data-cy="back"
          onClick={onBack}
        >
          {t(
            'atlas.actions.back',
            'Back',
            'Button to return to the previous page of a form',
          )}
        </StyledBackButton>
      )}
      {page === 1 && (
        <StyledButtonTertiary
          type="button"
          buttonSize="sm"
          condensed
          onClick={onClose}
        >
          {t('atlas.actions.close', 'Close', 'Action to close')}
        </StyledButtonTertiary>
      )}
      {page === 1 &&
        !isFetched &&
        (enablePage2 ? (
          <StyledButtonPrimary
            ref={lastBtnRef}
            buttonSize="sm"
            type="button"
            data-cy="next"
            disabled={submitButtonDisabled}
            onClick={onNext}
          >
            {t('atlas.actions.next', 'Next', 'Button text to go to next step')}
          </StyledButtonPrimary>
        ) : (
          <StyledButtonPrimary
            ref={lastBtnRef}
            buttonSize="sm"
            type="submit"
            data-cy="submit"
            disabled={submitButtonDisabled}
          >
            {t('atlas.actions.submit', 'Submit', 'Action to submit the form')}
          </StyledButtonPrimary>
        ))}
      {/* Page 2: the content-platform-ui <Form> renders its own Submit button. */}
    </>
  );
};
